import { Link } from 'wouter';
import { cn } from '@shared/lib';
import { brand } from '@brand';

interface BrandLogoProps {
  collapsed?: boolean;
  className?: string;
  href?: string;
}

export function BrandLogo({ collapsed = false, className, href = '/' }: BrandLogoProps) {
  const icon = <brand.components.LogoMark />;

  if (collapsed) {
    return (
      <Link href={href} className={cn('flex items-center justify-center', className)}>
        {icon}
      </Link>
    );
  }

  return (
    <Link href={href} className={cn('flex min-w-0 items-center gap-3', className)}>
      {icon}
      <div className="leading-tight min-w-0">
        <div className="truncate text-[18px] font-extrabold tracking-tight text-landing-ink">
          {brand.appName}
        </div>
        <div className="truncate text-[11.5px] font-medium text-landing-ink-nav">
          {brand.tagline}
        </div>
      </div>
    </Link>
  );
}
